import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export function DataGridCheckbox(props) {
  return (
    <Checkbox color="primary" {...props}>
      {' '}
      {props.children}
    </Checkbox>
  );
}

export default DataGridCheckbox;
